/* eslint-disable import/prefer-default-export */
import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function getCohortTags() {
  return Vue.axios.get(`${siteConfig.siteURL}cohorts/tags`)
}
